import { render, staticRenderFns } from "./PageInicial.vue?vue&type=template&id=461711a6&scoped=true"
var script = {}
import style0 from "./PageInicial.vue?vue&type=style&index=0&id=461711a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "461711a6",
  null
  
)

export default component.exports